export function hideSidebarDuplicatedProjects(context, once) {
  if (context) {
    const hideProjectItems = once(
      'hide-project-item',
      '.hide-project-items',
      context
    );

    hideProjectItems.forEach(function (div) {
      // Get the data-items attribute, which is a JSON-encoded array of IDs
      const itemIds = JSON.parse(div.getAttribute('data-items'));

      // Loop through each ID in the array
      itemIds.forEach(function (id) {
        // Find the element with the class "item-[id]" and hide it
        const itemDiv = context.querySelector(`.sidebar-map-item-${id}`);
        if (itemDiv) {
          itemDiv.classList.add('hidden'); // Hide the element
        }
      });

      // console.log('Hide duplicated projects', itemIds);
    });
  }
}
